import { Schema as S } from "effect";
export const Schema = S.Literal("play-store");
export const Value = "play-store";
